import React, { Component } from 'react'
import TableComp from '../../../../components/_utils/table'
//import { TableComp } from 'sz-react-utils'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import moment from 'moment'
import { Button, Card, notification, Popconfirm, Select, Tooltip, Row, Col } from 'antd'
import Request from '../../../../request'

import { Link } from "react-router-dom";

import { connect } from 'react-redux'
import styles from '../../country/all/styles.less'
import commonStyle from '../../../common.less'
import setting from '../../../../components/_utils/settings'
import { RightsWrapper } from '../../../../components/_utils/utils'
import rightAuth from '../../../../components/_utils/userRights'
import TransferCampus from '../../../../components/_utils/transferCampus'

const Option = Select.Option

class AllCampus extends Component {
    state = {
        total: 0,
        uniArr: [],
        campusUniversityId: '',
        showTransferForm: false,
        campusId: '',
        universityId: ''
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            if (this.state.campusUniversityId) {
                params.campusUniversityId = this.state.campusUniversityId
                params.page = 1
                params.deleted = false
            }

            let data = await Request.getAllCampus({
                ...params,
                regExFilters: ['campusName']
            })
            this.setState({ total: data.total })

            resolve(data)
        })
    }

    loadUni = async () => {
        let arr = await Request.loadSimpleUniversities()

        this.setState({ uniArr: arr.arr })
    }
    onUniChoose = v => {
        this.setState({ campusUniversityId: v }, () => {
            this.table.current.reload()
        })
    }

    handleTransfer = (campusId) => {
        return (
            this.setState({ showTransferForm: true, campusId: campusId._id, universityId: campusId.uniId })
        )
    }

    handleDelete = (universityId, campusId) => {
        Request.deleteCampus({ _id: universityId, campusId: campusId })
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    onClose = () => {
        this.setState({ showTransferForm: false, universityId: '', campusId: '' })
        this.table.current.reload()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()

        this.loadUni()
    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)

        if (searchParams.get('campusUniversityId')) {
            setTimeout(() => {
                this.setState(
                    { campusUniversityId: searchParams.get('campusUniversityId') },
                    () => {
                        this.table.current.reload()
                    }
                )
            }, 2000)
        }
    }

    render() {
        const columns = [
            {
                title: 'Campus',
                key: 'campusName',
                dataIndex: 'campusName',
                width: 300,
                fixed: 'left',
                sorter: true,
                searchTextName: 'campusName',
                filterRegex: true,
                render: (val, record) => {
                    return <React.Fragment>
                        {rightAuth.checkRights("Campus.edit") ? <RightsWrapper myRight={"Campus.edit"}>
                            <Tooltip title="Click To Edit Details">
                                <a
                                    href={`/master/edit-campus?id=${record._id
                                        }`}
                                >
                                    {record.campusName}
                                </a>
                            </Tooltip>
                        </RightsWrapper> : <React.Fragment>
                            {record.campusName}
                        </React.Fragment>}
                    </React.Fragment>;
                }
            },
            {
                title: 'University Country',
                key: 'universityCountryId',
                dataIndex: 'universityCountryId',
                render: (val, record) => {
                    return <span>{record.universityCountryId}</span>
                }
            },
            {
                title: 'University',
                searchTextName: 'universityInstitutionName',
                filterRegex: true,
                key: 'universityInstitutionName',
                dataIndex: 'universityInstitutionName'
            },
            {
                title: 'Updated By',
                width: 150,
                key: 'updatedByUser',
                dataIndex: 'updatedByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Created By',
                width: 150,
                key: 'createdByUser',
                dataIndex: 'createdByUser',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>{text ? text.name : ''} </div>
                            <small>
                                {text ? moment(text.time).format(setting.masterFormat) : ''}
                            </small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',

                width: 100,
                render: (text, record) => (<React.Fragment>
                    <Tooltip title="Delete Campus">
                        <Popconfirm
                            title="Are you sure to delete Campus?"
                            onConfirm={() => this.handleDelete(record.uniId, record._id)}
                            okText="Yes"
                            cancelText="No">
                            <Button
                                shape="circle"
                                className={styles.btn}
                                icon="delete" />
                        </Popconfirm>
                    </Tooltip>
                    <Tooltip title="Transfer Campus">
                        <Popconfirm
                            title="Are you sure to Transfer Campus?"
                            onConfirm={() => {
                                this.handleTransfer(record)
                            }}

                            okText="Yes"
                            cancelText="No">
                            <Button
                                className={styles.btn}
                                size={'small'}
                                style={{ marginLeft: '5px' }}
                                shape="circle"
                                icon="forward"
                            />
                        </Popconfirm>
                    </Tooltip>
                </React.Fragment>
                )
            }
            /* {
               title: 'Action',
               key: 'operation',
               fixed: 'right',

               render: (text, record) =>
                 (
                   <React.Fragment>
                     <Tooltip title="Edit Details">
                       <Button className={styles.btn}
                               shape="circle" onClick={() => {
                         dispatch(getUrlPushWrapper('masters.editCampus', { id: record._id }))
                       }} icon="edit"/>
                     </Tooltip>
                   </React.Fragment>
                 )
             }*/
        ]
        const { showTransferForm, universityId, campusId, uniArr } = this.state
        return (
            <PageHeaderWrapper title={`All Campus : ${this.state.total}`}>
                {
                    showTransferForm ?
                        <TransferCampus onClose={this.onClose} campusId={campusId} universityId={universityId} alluniversity={uniArr} />
                        : null
                }
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                            <h4>SEARCH BY UNIVERSITY</h4>
                            <Select
                                showSearch
                                allowClear
                                style={{ width: 350 }}
                                value={this.state.campusUniversityId}
                                placeholder="Select University"
                                optionFilterProp="universityInstitutionName"
                                onChange={this.onUniChoose}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    )
                                }}>
                                {this.state.uniArr.map((val, idn) => {
                                    return (
                                        <Option key={idn} value={val._id}>
                                            {val.universityInstitutionName}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </Col>
                        <Col span={10}>
                        </Col>
                        <Col span={2}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Link to='/master/add-campus'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1500 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 10,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllCampus)
